export const SAVED_CONTENT_REFRESH_EVENT = 'gt:saved-content-refresh';

export type SavedContentRefreshDetail = {
  /** Optional country name so listeners can scope refreshes if they want to. */
  country?: string | null;
  savedCount?: number;
  source?: string;
};

export function dispatchSavedContentRefresh(detail: SavedContentRefreshDetail = {}): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<SavedContentRefreshDetail>(SAVED_CONTENT_REFRESH_EVENT, { detail }));
}
